var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 4.03695 13.9642 0 9.00348 0C4.04279 0 0.00695119 4.03695 0.00695119 9C0.00695119 10.4333 0.353317 11.8539 1.01096 13.1274L0.048785 16.573C-0.149724 17.3431 0.266585 17.9858 1.13332 18C1.81331 18.0111 2.2945 17.9062 2.73802 17.7761L3.3952 17.5736C3.84134 17.4412 4.33038 17.3292 5.02346 17.3284C5.69571 17.3276 6.15992 17.4414 6.60901 17.5754L6.99474 17.6931C7.51611 17.8509 8.0897 18 9.00348 18C13.9642 18 18 13.9626 18 9ZM4.08953 6.79658C4.22583 6.6097 4.47732 6.49602 4.74769 6.49908H13.2444C13.5148 6.49602 13.7663 6.6097 13.9026 6.79658C14.0389 6.98346 14.0389 7.21459 13.9026 7.40147C13.7663 7.58835 13.5148 7.70202 13.2444 7.69896H4.74769C4.47732 7.70202 4.22583 7.58835 4.08953 7.40147C3.95323 7.21459 3.95323 6.98346 4.08953 6.79658ZM4.74769 9.99908C4.47732 9.99602 4.22583 10.1097 4.08953 10.2966C3.95323 10.4835 3.95323 10.7146 4.08953 10.9015C4.22583 11.0883 4.47732 11.202 4.74769 11.199H11.2452C11.5156 11.202 11.767 11.0883 11.9033 10.9015C12.0396 10.7146 12.0396 10.4835 11.9033 10.2966C11.767 10.1097 11.5156 9.99602 11.2452 9.99908H4.74769ZM1 9C1 4.58991 4.59004 1 9 1C13.41 1 17 4.58991 17 9C17 13.4098 13.4098 17 9 17C8.31321 17 7.92867 16.928 7.22406 16.7121L6.67728 16.5494C6.00861 16.3643 5.47398 16.2828 4.75122 16.2836C3.80032 16.2847 3.20392 16.4065 2.22039 16.716L1.75576 16.8557C1.574 16.9057 1.41892 16.9407 1.26761 16.9638L1.13227 16.9819L2.18163 13.2271L1.89288 12.6682L1.74019 12.3561C1.2543 11.3056 1 10.1561 1 9Z",
    fill: "url(#paint0_linear_5471_18889)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5471_18889",
    x1: 0.524511,
    y1: 0.589501,
    x2: 0.524511,
    y2: 17.5412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMessage);
export default __webpack_public_path__ + "static/media/pin_message.f4d7a6af1739931a09b2e5fdb39c5aee.svg";
export { ForwardRef as ReactComponent };